import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';
import { DropdownMixin } from './dropdownMixin.js';
import { Svg } from './Svg.js';

// _misc.js
/* global scrollToPageTop */
// header2.js
/* global toggleSignInOverlay */
// header1.js
/* global isLoggedIn */
// dcAnalytics.js
/* global dcAnalytics */


export const AddToChallengeWidget = createReactClass({
    propTypes: {
        project: PropTypes.object.isRequired,
        donorGivingPages: PropTypes.array.isRequired,
    },

    mixins: [PureRenderMixin, DropdownMixin],

    getDefaultProps: function () {
        return {
            donorGivingPages: [],
        };
    },

    getInitialState: function () {
        return {
            loading: false,
        };
    },

    handleCallback: function (response) {
        this.setState({
            loading: false,
            message: response.data.message || 'Successfully added!',
        });
    },

    showChallenges: function () {
        this.toggleOpen();
    },

    openSignin: function (event) {
        scrollToPageTop();
        this.close();
        toggleSignInOverlay();
        event.preventDefault();
    },

    render: function () {
        const props = this.props;
        const donorGivingPages = props.donorGivingPages;
        if (donorGivingPages.length === 0) {
            return <span></span>;
        }

        const project = props.project;
        const state = this.state;
        let dropdownContent;

        if (!isLoggedIn() && state.isOpen) {
            dropdownContent = <a href="#" onClick={this.openSignin}>Sign in to add project</a>;
        } else if (state.loading) {
            dropdownContent = <div className="loader"><div className="dot one"></div><div className="dot two"></div><div className="dot three"></div></div>;
        } else if (state.message) {
            dropdownContent = <p dangerouslySetInnerHTML={{ __html: state.message }}></p>;
        } else if (state.isOpen) {
            dropdownContent = donorGivingPages.map(function (givingPage) {
                const addChallenge = function (event) {
                    this.setState({
                        loading: true,
                    });
                    const urlString = secureBaseURL + 'donors/add_to_challenge.html';
                    $.ajax({
                        url: urlString,
                        method: 'POST',
                        dataType: 'json',
                        data: {
                            proposalId: project.id,
                            challengeId: givingPage.id,
                        },
                        // withCredentials is necessary to pass cookies since this is a cross-origin request
                        xhrFields: { withCredentials: true },
                    }).fail(function (xhr, status, err) {
                        console.log(props.url, status, err.toString());
                    }).done(this.handleCallback);

                    try {
                        if (pageName != '') {
                            dcAnalytics.trackEventGA([pageName, 'Link', 'Add to campaign']);
                        }
                    } catch (e) {
                        // do nothing
                    }
                    event.preventDefault();
                }.bind(this);
                return (
                    <div className="campaign-link" key={givingPage.id}>
                        <a href="#" onClick={addChallenge}>
                            {decodeURIComponent(givingPage.title)}
                        </a>
                    </div>
                );
            }.bind(this));
        }

        const openStyle = {
            display: dropdownContent ? 'block' : 'none',
        };

        return (
            <div className="add-to-campaign-holder">
                <div className="add-to-campaign" onClick={this.showChallenges}>
                    <Svg icon="flag" attributes={{ role: 'presentation' }}/>
                    Add to campaign
                </div>
                <div className="subnav campaign-popup ignore-react-onclickoutside" style={openStyle}>
                    {dropdownContent}
                </div>
            </div>
        );
    },
});
